import React from "react";
import {
  DataGrid,
  Column,
  FormItem,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import uiInfo from "../ui-info";
import { criarCefDs } from "../DataSources";
import PaginaToolbar from "../components/PaginaToolbar";
import { Button } from "devextreme-react";
import Form, {
  SimpleItem,
  GroupItem,
  Label,
  EmptyItem,
} from "devextreme-react/form";

export default class CefsBox extends React.Component {
  constructor() {
    super();
    this._gridInstance = React.createRef();
    this._gridAtualizarCefs = React.createRef();
    this.cefDs = criarCefDs();
    this.state = {
      filtro: {
        id: null,
        cv: null,
        modalidadeStr: null,
        semMovimento: 3,
        competencia: null,
        nome: null,
      },
    };
    this.filtrar = this.filtrar.bind(this);
    this.limparFiltro = this.limparFiltro.bind(this);

    this.options = {
      editorType: "dxSelectBox",
      searchEnabled: false,
      dataSource: [
        { id: 1, descricao: "SIM" },
        { id: 2, descricao: "NÃO" },
        { id: 3, descricao: "TODOS" },
      ],
      placeholder: "Escolher...",
      valueExpr: "id",
      displayExpr: "descricao",
    };
  }

  editar(e) {
    return console.log("editada");
  }

  cancelar(e) {
    return console.log("cancelada");
  }

  limparFiltro() {
    this.setState({
      filtro: {
        id: null,
        cv: null,
        modalidadeStr: null,
        semMovimento: null,
        competencia: null,
        nome: null,
      },
    });
    this.filtrar();
  }

  cellRender(data) {
    if (data.value) return "SIM";
    else return "NÃO";
  }

  filtrar() {
    let filtroCorrente = [];
    let estado = this.state.filtro;

    if (estado.id != null) {
      filtroCorrente.push(["id", "=", estado.id]);
    }

    if (estado.cv != null && estado.cv.trim() != "") {
      filtroCorrente.push(["cv", "contains", estado.cv]);
    }

    if (estado.modalidadeStr != null && estado.modalidadeStr.trim() != "") {
      filtroCorrente.push(["modalidadeStr", "contains", estado.modalidadeStr]);
    }

    if (estado.semMovimento != null && estado.semMovimento != 3) {
      filtroCorrente.push(["semMovimento", "=", estado.semMovimento === 1]);
    }

    if (estado.competencia != null) {
      filtroCorrente.push(["competencia", "=", estado.competencia]);
    }

    if (estado.nome != null && estado.nome.trim() != "") {
      filtroCorrente.push(["cpbs.nome", "contains", estado.nome]);
    }

    this._gridInstance.instance.filter(filtroCorrente.length > 0 ? filtroCorrente : null);
  }

  render() {
    return (
      <div className={"content-block dx-card responsive-paddings"}>
        <form onSubmit={this.filtrar}>
          <Form
            id="filtro-form"
            formData={this.state.filtro}
            colCount={12}
            labelLocation="top"
          >
            <GroupItem colCount={12} colSpan={12}>
              <SimpleItem colSpan={3} dataField="id">
                <Label text="ID" />
              </SimpleItem>

              <SimpleItem colSpan={3} dataField="cv">
                <Label text="CV" />
              </SimpleItem>

              <SimpleItem colSpan={3}
                dataField="semMovimento"
                editorType="dxSelectBox"
                editorOptions={this.options}
              >
                <Label text="Sem Movimento" />
              </SimpleItem>

              <SimpleItem colSpan={3} dataField="competencia">
                <Label text="Competência" />
              </SimpleItem>

              

              <SimpleItem colSpan={12} dataField="nome">
                <Label text="Nome" />
              </SimpleItem>
            </GroupItem>
          </Form>
          <div style={{ marginTop: "20px" }}>
            <div style={{ display: "inline-block" }}>
              <Button
                width={120}
                text="Filtrar"
                type="success"
                onClick={this.filtrar}
              />
            </div>
            <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button text="Limpar Filtro" onClick={this.limparFiltro} />
            </div>
          </div>
        </form>
        <br />
        <br />
        <PaginaToolbar titulo="Lista de CEF's" ocultarNovo={true}>
          <DataGrid
            ref={(grid) => (this._gridInstance = grid)}
            dataSource={this.cefDs}
            showBorders={true}
            rowAlternationEnabled={true}
            remoteOperations={true}
            columnAutoWidth={true}
            focusedRowEnabled={false}
            allowColumnReordering={true}
          >
            <Column
              type="buttons"
              fixed={true}
              fixedPosition={"left"}
              buttons={[
                {
                  hint: "Cancelar",
                  icon: "remove",
                  onClick: (e) => {
                    this.cancelCef(e);
                  },
                },
                {
                  hint: "Editar",
                  icon: "edit",
                  onClick: (e) => this.editCef(e),
                },
              ]}
            />
            <Column
              dataField={"id"}
              visible={true}
              caption={"ID"}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"cv"}
              visible={true}
              caption={"CV"}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"cpbs.nome"}
              visible={true}
              caption={"Nome"}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"modalidadeStr"}
              caption={"Modalidade"}
              visible={true}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"semMovimento"}
              visible={true}
              showInColumnChooser={false}
              cellRender={this.cellRender}
            >
              <FormItem visible={true}></FormItem>
            </Column>
            <Column
              dataField={"competencia"}
              caption={"Competência"}
              visible={true}
              showInColumnChooser={false}
            >
              <FormItem visible={true}></FormItem>
            </Column>

            <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />

            <Pager
              showInfo={true}
              showNavigationButtons={true}
              showPageSizeSelector={true}
              allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
            />
          </DataGrid>
        </PaginaToolbar>
      </div>
    );
  }
}
